<app-loading *ngIf="isLoading$ | async" [options]="(loadingOpts$ | async) ?? undefined" />

<!--Desktop Nav-->
<ng-container *ngIf="!(isTabletOrSmaller$ | async)">
  <app-desktop-nav />
</ng-container>
<!--Desktop Nav-->

<!--Mobile Nav-->
<ng-container *ngIf="isTabletOrSmaller$ | async">
  <app-mobile-nav />
</ng-container>
<!--Mobile Nav-->
